<div class="{{localService.selectedLanguageCode}}">
    <app-popup-header title="Select Receipt Template" />
    <div class="modal-body">
        <div *ngFor="let item of items">
            <button class="button_link link_btn" (click)="onRoute(item.key)">
                <span>{{item.value}}</span>
            </button>
        </div>
    </div>
</div>